import { TdUI } from 'td-vue3-ui'
import 'td-vue3-ui/lib/style.css'
import { TdAdmin, registerWorkFlowConfig } from 'td-admin-vue'
import 'td-admin-vue/lib/style.css'
import { TdPunish, WorkFlowDConfigData } from 'td-punish-hbb'
import 'td-punish-hbb/lib/style.css'
import { TdRegulation } from 'td-regulation-vue'
import 'td-regulation-vue/lib/style.css'
import '../public/animate.min.css'
import { TdPenalize } from './mod'
import { TdKnowledge } from 'td-knowledge-vue'
import 'td-knowledge-vue/lib/style.css'
import { TdSwitchDataManage } from 'td-switch-data-manage-vue'
import 'td-switch-data-manage-vue/lib/style.css'
import entry from './app.vue'
//注册工作流配置信息
registerWorkFlowConfig(WorkFlowDConfigData)
/**注册admin模块 */
TdUI.registerModule(TdAdmin)
/**注册行政处罚模块 */
TdUI.registerModule(TdPunish)
/**注册裁量计算器模块 */
TdUI.registerModule(TdRegulation)
/**注册知识库 */
TdUI.registerModule(TdKnowledge)
/**数据同步 */
TdUI.registerModule(TdSwitchDataManage)
TdUI.registerModule(TdPenalize)
TdUI.start({ entry })
